export enum userRolesEnum {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_PORTAL_CUSTOMER = 'ROLE_PORTAL_CUSTOMER',
  ROLE_PORTAL_ADMIN_HANDOVER = 'ROLE_PORTAL_ADMIN_HANDOVER',
}
